import { makeRequest } from 'utils/requestLogger';

export default (submissionID) =>
  makeRequest('get', `/api/submissions/${submissionID}`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/viewSubmission.js